import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import SignIn from "./pages/SignIn";
import EmailV from "./pages/EmailV";
import SuperAdminDashboard from "./pages/SuperAdminDashboard";
import HospitalAdminDashboard from "./pages/HospitalAdminDashboard";
import DoctorDashboard from "./pages/DoctorDashboard";
import MedicalStuffDashboard from "./pages/MedicalStuffDashboard";

const pageTitles = {
  "/": "CareTech - Home",
  "/home": "CareTech - Home",
  "/signin": "CareTech - Sign In",
  "/email-verification": "CareTech - Email Verification",
  "/super-admin-dashboard": "CareTech - Super Admin Dashboard",
  "/hospital-admin-dashboard": "CareTech - Hospital Admin Dashboard",
  "/doctor-dashboard": "CareTech - Doctor Dashboard",
  "/medical-stuff-dashboard": "CareTech - Medical Staff Dashboard",
};

const TitleUpdater = () => {
  const location = useLocation();
  useEffect(() => {
    document.title = pageTitles[location.pathname] || "CareTech";
  }, [location]);
  return null;
};

/**
 * ProtectedRoute — vérifie la session avant d'afficher la page protégée.
 * Utilise localStorage ET sessionStorage comme double filet pour éviter
 * les déconnexions intempestives lors de la navigation entre onglets.
 */
const ProtectedRoute = ({ allowedRoles, children }) => {
  // Lecture depuis localStorage (persistant) ET sessionStorage (onglet courant)
  const userRole =
    localStorage.getItem("userRole") ||
    sessionStorage.getItem("userRole");

  // Synchronise sessionStorage depuis localStorage si absent
  useEffect(() => {
    const lsRole = localStorage.getItem("userRole");
    if (lsRole && !sessionStorage.getItem("userRole")) {
      sessionStorage.setItem("userRole", lsRole);
      sessionStorage.setItem("userId",   localStorage.getItem("userId") || "");
      sessionStorage.setItem("username", localStorage.getItem("username") || "");
    }
  }, []);

  if (!userRole) return <Navigate to="/signin" replace />;
  if (!allowedRoles.includes(userRole)) return <Navigate to="/home" replace />;
  return children;
};

export default function App() {
  return (
    <BrowserRouter>
      <TitleUpdater />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/email-verification" element={<EmailV />} />

        <Route
          path="/super-admin-dashboard"
          element={<ProtectedRoute allowedRoles={["super-admin"]}><SuperAdminDashboard /></ProtectedRoute>}
        />
        <Route
          path="/hospital-admin-dashboard"
          element={<ProtectedRoute allowedRoles={["admin"]}><HospitalAdminDashboard /></ProtectedRoute>}
        />
        <Route
          path="/doctor-dashboard"
          element={<ProtectedRoute allowedRoles={["doctor"]}><DoctorDashboard /></ProtectedRoute>}
        />
        <Route
          path="/medical-stuff-dashboard"
          element={<ProtectedRoute allowedRoles={["medical_stuff"]}><MedicalStuffDashboard /></ProtectedRoute>}
        />

        <Route path="*" element={<Navigate to="/home" />} />
      </Routes>
    </BrowserRouter>
  );
}